import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import "./buttonSelect.scss";

const ButtonSelect = (props) => {
  const [selected, setSelected] = React.useState(false);

  React.useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const onChangeHandler = () => {
    const value = !selected;
    setSelected(value);
    props.onChange(value);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ToggleButton
        value="check"
        selected={selected}
        onChange={onChangeHandler}
        className="ToggleButton"
      >
        {props.label}
      </ToggleButton>
    </StyledEngineProvider>
  );
};

export default ButtonSelect;
